import { SegmentService } from '@pflegia/segment-ui/segment.service';

import { integrations } from '../tracking/integrations';
import { getPageType } from './types/get-page-type';

export const segmentService = new SegmentService(integrations, {
  ga4MeasurementId: process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID,
  // eslint-disable-next-line eslint-compat/camelcase
  getPageProperties: (pathname: string) => ({ page_type: getPageType(pathname) }),
});
